module.exports = __webpack_public_path__ + "img/button_yellow.62619da9.png";